import React, { useState, createContext } from 'react';
import { IPiece } from 'src/api/models/Piece';
import { PropsWithChildren } from 'src/PropsWithChildren';

interface IPathContext {
  location: string | null;
  updateLocation: (path: string | null) => void;
}

export const PathContext = createContext<IPathContext>({
  location: null,
  updateLocation: () => {},
});

export const PathProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [location, setLocation] = useState<string | null>(null);

  const updateLocation = (path: string | null) => {
    setLocation(path);
  };
  return (
    <PathContext.Provider value={{ location, updateLocation }}>
      {children}
    </PathContext.Provider>
  );
};

export const usePath: () => IPathContext = () => {
  const context = React.useContext(PathContext);
  return { ...context };
};
